import { hot } from 'react-hot-loader/root';
import React from 'react';
import { MujiRouter, Router } from '@souche-f2e/muji';
const routes = [
    {
        "path": "/",
        "children": [
            {
                "path": "",
                "component": Promise.resolve(() => import('../pages/index'))
            },
            {
                "path": "Auction",
                "children": [
                    {
                        "path": "BidManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Auction/BidManage/index'))
                            },
                            {
                                "path": "BidDetail",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/BidManage/BidDetail/index'))
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "path": "SceneManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Auction/SceneManage/index'))
                            },
                            {
                                "path": "AddPrice",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/AddPrice/index'))
                                    }
                                ]
                            },
                            {
                                "path": "Auctioneer",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/Auctioneer/index'))
                                    }
                                ]
                            },
                            {
                                "path": "Screen",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/Screen/index'))
                                    }
                                ]
                            },
                            {
                                "path": "SessionDetail",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/SessionDetail/index'))
                                    }
                                ]
                            },
                            {
                                "path": "SessionEdit",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/SessionEdit/index'))
                                    }
                                ]
                            },
                            {
                                "path": "SessionPrint",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Auction/SceneManage/SessionPrint/index'))
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "path": "CarManage",
                "children": [
                    {
                        "path": "",
                        "component": Promise.resolve(() => import('../pages/CarManage/index'))
                    },
                    {
                        "path": "CreateSession",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/CreateSession/index'))
                            }
                        ]
                    },
                    {
                        "path": "Deal",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/Deal/index'))
                            }
                        ]
                    },
                    {
                        "path": "DealDetail",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/DealDetail/index'))
                            }
                        ]
                    },
                    {
                        "path": "OfferCeneList",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/OfferCeneList/index'))
                            }
                        ]
                    },
                    {
                        "path": "OfferDetails",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/OfferDetails/index'))
                            }
                        ]
                    },
                    {
                        "path": "RealtimeMonitoring",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/CarManage/RealtimeMonitoring/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "DataStatistics",
                "children": [
                    {
                        "path": "Analysis",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/DataStatistics/Analysis/index'))
                            }
                        ]
                    },
                    {
                        "path": "Overview",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/DataStatistics/Overview/index'))
                            }
                        ]
                    },
                    {
                        "path": "ReportList",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/DataStatistics/ReportList/index'))
                            },
                            {
                                "path": "ReportCreate",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/DataStatistics/ReportList/ReportCreate/index'))
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "path": "ApproveManage",
                "children": [
                    {
                        "path": "AllApproveManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/ApproveManage/AllApproveManage/index'))
                            },
                            {
                                "path": "CreateSession",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/ApproveManage/AllApproveManage/CreateSession/index'))
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "path": "MyApproveManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/ApproveManage/MyApproveManage/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "Finance",
                "children": [
                    {
                        "path": "CashManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Finance/CashManage/index'))
                            }
                        ]
                    },
                    {
                        "path": "GroupAccountManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Finance/GroupAccountManage/index'))
                            },
                            {
                                "path": "AccountDetail",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Finance/GroupAccountManage/AccountDetail/index'))
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "path": "GroupMoneyManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Finance/GroupMoneyManage/index'))
                            }
                        ]
                    },
                    {
                        "path": "MoneyManage",
                        "children": [
                            {
                                "path": "BuyerMargin",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Finance/MoneyManage/BuyerMargin/index'))
                                    },
                                    {
                                        "path": "Detail",
                                        "children": [
                                            {
                                                "path": "",
                                                "component": Promise.resolve(() => import('../pages/Finance/MoneyManage/BuyerMargin/Detail/index'))
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "path": "SellerMargin",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/Finance/MoneyManage/SellerMargin/index'))
                                    },
                                    {
                                        "path": "Detail",
                                        "children": [
                                            {
                                                "path": "",
                                                "component": Promise.resolve(() => import('../pages/Finance/MoneyManage/SellerMargin/Detail/index'))
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "path": "PayManage",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Finance/PayManage/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "Home",
                "children": [
                    {
                        "path": "",
                        "component": Promise.resolve(() => import('../pages/Home/index'))
                    }
                ]
            },
            {
                "path": "Operating",
                "children": [
                    {
                        "path": "CarouselSet",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Operating/CarouselSet/index'))
                            }
                        ]
                    },
                    {
                        "path": "CompanySet",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Operating/CompanySet/index'))
                            }
                        ]
                    },
                    {
                        "path": "MarketingTools",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/Operating/MarketingTools/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "OrderManage",
                "children": [
                    {
                        "path": "",
                        "component": Promise.resolve(() => import('../pages/OrderManage/index'))
                    },
                    {
                        "path": "ConfirmTransferInfo",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/OrderManage/ConfirmTransferInfo/index'))
                            }
                        ]
                    },
                    {
                        "path": "WaitTransfer",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/OrderManage/WaitTransfer/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "System",
                "children": [
                    {
                        "path": "ArgueRules",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/System/ArgueRules/index'))
                            }
                        ]
                    },
                    {
                        "path": "AuctionRules",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/System/AuctionRules/index'))
                            }
                        ]
                    },
                    {
                        "path": "SellerPayRules",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/System/SellerPayRules/index'))
                            }
                        ]
                    },
                    {
                        "path": "TenantsRules",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/System/TenantsRules/index'))
                            }
                        ]
                    }
                ]
            },
            {
                "path": "Account",
                "children": [
                    {
                        "path": "",
                        "component": Promise.resolve(() => import('../pages/Account/index'))
                    }
                ]
            },
            {
                "path": "DealerManage",
                "children": [
                    {
                        "path": "Buyer",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/DealerManage/Buyer/index'))
                            }
                        ]
                    },
                    {
                        "path": "Seller",
                        "children": [
                            {
                                "path": "",
                                "component": Promise.resolve(() => import('../pages/DealerManage/Seller/index'))
                            },
                            {
                                "path": "components",
                                "children": [
                                    {
                                        "path": "",
                                        "component": Promise.resolve(() => import('../pages/DealerManage/Seller/components/index'))
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "component": Promise.resolve(() => import('../pages/_layout/index'))
    }
];
routes.push({
    "path": "*",
    "component": require('../pages/404').default,
});
const routerOptions = {
    mode: "hash",
    routes,
};
export const router = new Router(routerOptions);
const Root = () => (<MujiRouter router={router}/>);
export default hot(Root);
